import { render, staticRenderFns } from "./Customize.vue?vue&type=template&id=ed5bc96c&"
import script from "./Customize.vue?vue&type=script&lang=ts&"
export * from "./Customize.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports